<template>
    <div class="q-layout q-layout--containerized">
        <div class="main-wrapper">
            <div class="containerLS">
                <div class="banner-row">
                    <span class="banner-text">
                        {{ arr_lang.home['HOME.POPULAR_LIVE_STREAM'] }}
                        <small>{{ arr_lang.home['HOME.LIVE_STREAM_DESCRIPTION'] }}</small>
                    </span>
                </div>
                <div class="website-wrap" v-if="!isMobile">
                    <div class="MLSrow1">
                        <div class="MLScolB1" :style="(Object.keys(selectedMatch).length > 0)? 'visibility: visible;':'visibility: hidden;'">
                            <template v-if="Object.keys(selectedMatch).length > 0">
                                <span class="MLSicon" :class="'g'+selectedMatch.sptid+'-icon'"></span>
                                <div class="lsteam">
                                    <span class="MLSteams title-teama" :title="selectedMatch.tacap" :style="['1','2'].includes(selectedMatch.sptid)? 'max-width: 132px;':'max-width: 170px;'">{{ selectedMatch.tacap }}</span>
                                    <div class="team_logo ta_logo" v-if="['1','2'].includes(selectedMatch.sptid) && selectedMatch.talogo"><img :src="selectedMatch.talogo"></div>
                                </div>
                                <!-- <span> {{ selectedMatch.score }} </span> -->
                                <span> VS </span>
                                <div class="lsteam">
                                    <div class="team_logo tb_logo" v-if="['1','2'].includes(selectedMatch.sptid) && selectedMatch.tblogo"><img :src="selectedMatch.tblogo"></div>
                                    <span class="MLSteams title-teamb" :title="selectedMatch.tbcap" :style="['1','2'].includes(selectedMatch.sptid)? 'max-width: 132px;':'max-width: 170px;'">{{ selectedMatch.tbcap }}</span>
                                </div>
                            </template>
                        </div>
                        <div class="right-fixed">
                            <div class="MLScolA1" aria-label="button group">
                                <button class="scroll-MLSbtn" id="scrollLeft" @click="clickToScroll('left')" disabled="">◀</button>
                                <div class="MLSscroll-wrapper" id="scrollContainer" role="group" aria-label="items" ref="tabWrapList">
                                    <template v-for="(sport, key) in titleSport">
                                        <button class="btn-ls-game" :class="selectedSport == sport.sid[0]? 'active-MLSbtn':'inactive-MLSbtn'" :id="'btnLSGame'+sport.sid[0]" @click="onSportClick(sport.sid[0], $event)">{{ arr_lang.configLang[sport.titleLang] }}</button>
                                    </template>
                                </div>
                                <button class="scroll-MLSbtn" id="scrollRight" @click="clickToScroll('right')">▶</button>
                            </div>
                            <div class="searchMLS-container">
                                <input type="text" id="searchInput" class="searchMLS-input" :placeholder="arr_lang.home['HOME.ENTER_LEAGUE_TEAM']" v-model="searchKeyword">
                            </div>
                        </div>
                    </div>
                    <div class="MLSrow2">
                        <div class="leftMLS-col" id="LSTV">
                            <iframe v-if="Object.keys(selectedMatch).length > 0 && selectedMatch.tvlink" id="mainLSTViframe" style="border: none; position: absolute; inset: 0px; width: 100%; height: auto; aspect-ratio: 16 / 9;" :src="selectedMatch.tvlink" allowfullscreen="" webkitallowfullscreen="" mozallowfullscreen="" allow="fullscreen; accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" referrerpolicy="no-referrer" sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-pointer-lock allow-modals"></iframe>
                            <div class="leftMLS-col-text" :class="{ 'wave-text': firstLoad == 1 }" v-else>
                                <template v-if="firstLoad == 1">{{ arr_lang.home['HOME.LIVESTREAM_WAIT'] }}</template>
                                <template v-else>{{ arr_lang.home['HOME.NO_LIVE_NOW'] }}</template>
                            </div>
                        </div>
                        <div class="rightMLS-col scrollable">
                            <template v-if="sortedliveMatchList && sortedliveMatchList.length > 0">
                                <template v-for="(val, key) in sortedliveMatchList">
                                    <div class="lsmatch-info lsmatch" :class="'lsmatchbygame_'+val.sptid" :id="'lsm_'+val.eveid" @click="getLiveStreamURL(val)">
                                        <div class="lstlg-row">
                                            <div class="lstlg-icon" :class="['g'+val.sptid+'-icon', { 'rb':(val.rb == 1 && val.rbstatus == 1) }, { 'selected':(val.eveid == selectedMatch.eveid) }]"></div>
                                            <div class="lstlg" :title="val.lgecap">{{ val.lgecap }}</div>
                                        </div>
                                        <div class="match-content">
                                            <div class="lsteam">
                                                <div class="team_logo ta_logo" v-if="['1','2'].includes(val.sptid) && val.talogo"><img :src="val.talogo"></div>
                                                <div class="lsta" :title="val.tacap">{{ val.tacap }}</div>
                                            </div>
                                            <div class="lsti">
                                                <div>{{ val.score }}</div>
                                                <div class="lstdt" :class="{ 'streaming':(val.rb == 1 && val.rbstatus == 1) }">{{ (val.rb == 1 && val.rbstatus == 1)? arr_lang.home['HOME.STREAMING']:getDateTimeFormat(val.dt) }}</div>
                                            </div>
                                            <div class="lsteam">
                                                <div class="lstb" :title="val.tbcap">{{ val.tbcap }}</div>
                                                <div class="team_logo tb_logo" v-if="['1','2'].includes(val.sptid) && val.tblogo"><img :src="val.tblogo"></div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </template>
                            <template v-else>
                            <div class="lsmatch-info no-match lsmatchbygame_3">{{ arr_lang.home['HOME.NO_LIVE_MATCH'] }}</div>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="mobile-wrap" v-if="isMobile">
                    <div class="MLSrow1">
                        <div class="right-fixed" :class="{ focus: isSearchFocus }">
                            <div class="MLScolA1" aria-label="button group">
                                <!-- <button class="scroll-MLSbtn" id="scrollLeft" @click="clickToScroll('left')" disabled="">◀</button> -->
                                <div class="MLSscroll-wrapper mob-dev" id="scrollContainer" role="group" aria-label="items" ref="tabWrapList">
                                    <template v-for="(sport, key) in titleSport">
                                        <button class="btn-ls-game" :class="selectedSport == sport.sid[0]? 'active-MLSbtn':'inactive-MLSbtn'" :id="'btnLSGame'+sport.sid[0]" @click="onSportClick(sport.sid[0], $event)">
                                            <div class="btn-ls-game-icon" :class="['g'+sport.sid[0]+'-icon', { 'selected': selectedSport == sport.sid[0] }]"></div>
                                            <div v-if="!hideSportTitle">{{ arr_lang.configLang[sport.titleLang] }}</div>
                                        </button>
                                    </template>
                                </div>
                                <!-- <button class="scroll-MLSbtn" id="scrollRight" @click="clickToScroll('right')">▶</button> -->
                            </div>
                            <div class="searchMLS-container">
                                <input type="text" id="searchInput" class="searchMLS-input" :placeholder="arr_lang.home['HOME.ENTER_LEAGUE_TEAM']" v-model="searchKeyword" @click="onSearchFocus">
                                <button v-if="isSearchFocus" class="search-close" @click="closeSearch">✕</button>
                            </div>
                        </div>
                    </div>
                    <div class="MLSrow2">
                        <div class="rightMLS-col scrollable">
                            <template v-if="sortedliveMatchList && sortedliveMatchList.length > 0">
                                <template v-for="(val, key) in sortedliveMatchList">
                                    <div class="lsmatch-info lsmatch" :class="'lsmatchbygame_'+val.sptid" :id="'lsm_'+val.eveid" @click="getLiveStreamURL(val)">
                                        <div class="lstlg-row">
                                            <div class="lstlg-icon" :class="['g'+val.sptid+'-icon', { 'rb':(val.rb == 1 && val.rbstatus == 1) }, { 'selected':(val.eveid == selectedMatch.eveid) }]"></div>
                                            <div class="lstlg" :title="val.lgecap">{{ val.lgecap }}</div>
                                        </div>
                                        <div class="match-content">
                                            <div class="lsteam">
                                                <div class="team_logo ta_logo" v-if="['1','2'].includes(val.sptid) && val.talogo"><img :src="val.talogo"></div>
                                                <div class="lsta" :title="val.tacap">{{ val.tacap }}</div>
                                            </div>
                                            <div class="lsti">
                                                <div>{{ val.score }}</div>
                                                <div class="lstdt" :class="{ 'streaming':(val.rb == 1 && val.rbstatus == 1) }">{{ (val.rb == 1 && val.rbstatus == 1)? arr_lang.home['HOME.STREAMING']:getDateTimeFormat(val.dt) }}</div>
                                            </div>
                                            <div class="lsteam">
                                                <div class="lstb" :title="val.tbcap">{{ val.tbcap }}</div>
                                                <div class="team_logo tb_logo" v-if="['1','2'].includes(val.sptid) && val.tblogo"><img :src="val.tblogo"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="leftMLS-col" :id="'LSTV'+val.eveid" v-if="Object.keys(selectedMatch).length > 0 && val.eveid == selectedMatch.eveid">
                                        <iframe v-if="selectedMatch.tvlink" id="mainLSTViframe" style="border: none; position: absolute; inset: 0px; width: 100%; height: auto; aspect-ratio: 16 / 9;" :src="selectedMatch.tvlink" allowfullscreen="" webkitallowfullscreen="" mozallowfullscreen="" allow="fullscreen; accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" referrerpolicy="no-referrer" sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-pointer-lock allow-modals"></iframe>
                                        <div class="leftMLS-col-text" :class="{ 'wave-text': firstLoad == 1 }" v-else>
                                            <template v-if="firstLoad == 1">{{ arr_lang.home['HOME.LIVESTREAM_WAIT'] }}</template>
                                            <template v-else>{{ arr_lang.home['HOME.NO_LIVE_NOW'] }}</template>
                                        </div>
                                    </div>
                                </template>
                            </template>
                            <template v-else>
                                <div class="lsmatch-info no-match lsmatchbygame_3">{{ arr_lang.home['HOME.NO_LIVE_MATCH'] }}</div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div id="page-footer" class="clearfix">
                Copyright &copy; 2025 BeFun Score. {{arr_lang.home['HOME.ALL_RIGHT_RESERVED']}}
        </div> -->
    </div>
</template>

<script>
  import {
    mapGetters
  } from 'vuex'
  import vueCookie from 'vue-cookie'
  import EventBus from '@/vue/events/event-bus'
  import moment from 'moment'

  export default {
    components: {
    },
    data() {
        return {
            dragEnabled: true,
            hasDragged: false,
            isDragging: false,
            startX: 0,
            scrollLeftStart: 0,
            velocity: 0,
            lastX: 0,
            lastTime: 0,
            timerSeconds: window.timerSeconds,
            timerId: null,
            valid: window.valid,
            isSearchFocus: false,
            hideSportTitle: window.hideSportTitle,
        }
    },
    computed:{
        ...mapGetters([
            'arr_lang',
            'titleSport',
            'lang_id',
            'liveMatchList',
            'sortedliveMatchList',
            'selectedMatch',
            'selectedSport',
            'firstLoad',
            'minWidth',
            'isMobile',
        ]),
        searchKeyword : {
            set(val){
                this.$store.commit('SET_KEYWORD', val)
                this.$store.dispatch('sortLiveMatch')
            },
            get(){
                return this.$store.getters.keyword
            }
        },
    },
    watch: {
        selectedMatch(newval) {
            // console.log('aa')
            this.$nextTick(() => {
            const container = document.querySelector('.scroll');
            const el = document.getElementById('lsm_' + newval.eveid);
            const banner = document.querySelector('.banner-row');
            const nav = document.querySelector('.MLSrow1');

            if (!container || !el) return;

            const elRect = el.getBoundingClientRect();
            const bannerRect = banner.getBoundingClientRect();
            const navRect = nav.getBoundingClientRect();
            const target = bannerRect.height + navRect.height;

            container.scrollTop = container.scrollTop + elRect.top - target
            })
        },
    },
    methods: {
        clickToScroll(side) {
            const scrollAmount = 150;
            const container = this.$refs.tabWrapList;

            container.style.scrollBehavior = 'smooth';
            container.scrollBy({ left: side === 'left' ? -scrollAmount : scrollAmount });
            setTimeout(() => container.style.scrollBehavior = 'auto', 300);
            this.updateScrollButtons();
        },
        updateScrollButtons() {
            const container = this.$refs.tabWrapList;
            if(!container) return
            const leftDisabled = container.scrollLeft <= 0;
            const rightDisabled = container.scrollLeft + container.clientWidth >= container.scrollWidth - 1;

            const scrollLeftBtn = document.getElementById('scrollLeft');
            const scrollRightBtn = document.getElementById('scrollRight');
            if(!scrollLeftBtn || !scrollLeftBtn) return
            scrollLeftBtn.disabled = leftDisabled;
            scrollRightBtn.disabled = rightDisabled;
        },
        startDrag(e) {
            if (!this.dragEnabled) return;
            this.isDragging = true;
            this.hasDragged = false;
            this.startX = e.pageX || e.touches[0].pageX;
            this.scrollLeftStart = this.$refs.tabWrapList.scrollLeft;
            this.lastX = this.startX;
            this.lastTime = performance.now();
            this.velocity = 0;
            this.$refs.tabWrapList.classList.add('dragging');
        },
        duringDrag(e) {
            if (!this.dragEnabled || !this.isDragging) return;
            e.preventDefault();
            const x = e.pageX || e.touches[0].pageX;
            const delta = this.startX - x;

            if (Math.abs(delta) > 5) {
                this.hasDragged = true;
                e.preventDefault();
            }

            this.$refs.tabWrapList.scrollLeft = this.scrollLeftStart + delta;

            // Calculate velocity
            const now = performance.now();
            const dt = now - this.lastTime;
            if (dt > 0) {
                this.velocity = (this.lastX - x) / dt; // pixels/ms
                this.lastX = x;
                this.lastTime = now;
            }
        },
        stopDrag() {
            if (!this.dragEnabled) return;
            this.isDragging = false;
            this.$refs.tabWrapList.classList.remove('dragging');
            setTimeout(() => this.updateScrollButtons(), 50);
            setTimeout(() => {
                this.hasDragged = false;
            }, 0);
        },
        clearSearchBox() {
            this.searchKeyword = "";
        },
        onSportClick(sid, e) {
            if (this.hasDragged) {
                e.preventDefault();
                e.stopPropagation();
                return;
            }
            this.getLSMatchList(sid);
        },
        getLSMatchList(sid = '') {
            if(window.valid) {
                document.querySelector('.rightMLS-col.scrollable').scrollTop = 0
                this.clearSearchBox()
                // this.$store.commit('SELECTED_SPORT',sid);
                this.$store.dispatch('getLiveMatchList', {
                    sport: sid,
                    lang: this.lang_id,
                    loading:0,
                    token: token.arr_6
                })
            }
        },
        startTimer() {
            if(this.timerId == null){
                this.timerId = setInterval(() => {
                    if(this.timerSeconds - 1 < 0) {
                        this.reloadTable(token.arr_1)
                    } else {
                        this.timerSeconds -= 1;
                    }
                },1000);
            }
        },
        refreshTimer () {
            this.clearTimer()
            this.timerSeconds = window.timerSeconds
            this.startTimer()
        },
        clearTimer() {
            clearInterval(this.timerId)
            this.timerId = null
        },
        reloadTable(token_val=null){
            if(window.valid) {
                this.$store.dispatch('getLiveMatchList', {
                    sport: this.selectedSport,
                    lang: this.lang_id,
                    loading:0,
                    token: token_val
                })
                this.refreshTimer()
            } else {
                this.clearTimer()
            }
        },
        getLiveStreamURL(eve) {
            if(window.valid) {
                this.$store.commit('SELECTED_SPORT',eve.sptid);
                this.$store.dispatch('updateSelectedMatch', eve)
            }
        },
        getDateTimeFormat(dt) {
            return new moment(dt).format("YYYY-MM-DD HH:mm")
        },
        onSearchFocus() {
            // if (window.innerWidth <= 768) {
                this.isSearchFocus = true
            // }
        },
        closeSearch() {
            this.isSearchFocus = false
            this.clearSearchBox()
        },
        handleResize() {
            this.$store.commit('IS_MOBILE', window.innerWidth < this.minWidth)
            this.$nextTick(() => {
                this.unbindScrollEvents();
                this.dragEnabled = !this.isMobile;
                if (!this.isMobile) {
                    this.bindScrollEvents();
                    this.updateScrollButtons();
                }
            });
            if(this.isMobile) {
                const banner = document.querySelector('.banner-row');
                const mobileWrap = document.querySelector('.mobile-wrap');
                if (!banner || !mobileWrap) return
                const nav = mobileWrap.querySelector('.MLSrow1');
                const el  = mobileWrap.querySelector('.MLSrow2');
                if (!nav || !el) return;
                const bannerRect = banner.getBoundingClientRect();
                const navRect = nav.getBoundingClientRect();
                const target = bannerRect.height + navRect.height - 10;
                el.style.marginTop = target+'px';
            } else {
                const el  = document.querySelector('.MLSrow2');
                if (!el) return;
                el.style.marginTop = '';
            }
            if (this.pointerMQ) {
                this.handlePointerChange()
            }
        },
        handlePointerChange() {
            const isTouch = this.pointerMQ.matches
            this.$nextTick(() => {
                this.unbindScrollEvents();
                this.dragEnabled = !isTouch;

                const el = this.$refs.tabWrapList;
                if (!el) return;

                el.classList.toggle('mob-dev', isTouch);
                el.classList.toggle('web-dev', !isTouch);

                if (!isTouch) {
                    this.bindScrollEvents();
                }
            });
        },
        bindScrollEvents() {
            if (!this.dragEnabled) return;
            const container = this.$refs.tabWrapList;
            if (!container) return;

            container.addEventListener('scroll', this.updateScrollButtons);
            window.addEventListener('resize', this.updateScrollButtons);
            container.addEventListener('mousedown', this.startDrag);
            container.addEventListener('mousemove', this.duringDrag);
            container.addEventListener('mouseup', this.stopDrag);
            container.addEventListener('mouseleave', this.stopDrag);

            container.addEventListener('touchstart', this.startDrag, { passive: false });
            container.addEventListener('touchmove', this.duringDrag, { passive: false });
            container.addEventListener('touchend', this.stopDrag);
            container.addEventListener('touchcancel', this.stopDrag);
        },
        unbindScrollEvents() {
            const container = this.$refs.tabWrapList;
            if (!container) return;

            container.removeEventListener('scroll', this.updateScrollButtons);
            window.removeEventListener('resize', this.updateScrollButtons);
            container.removeEventListener('mousedown', this.startDrag);
            container.removeEventListener('mousemove', this.duringDrag);
            container.removeEventListener('mouseup', this.stopDrag);
            container.removeEventListener('mouseleave', this.stopDrag);

            container.removeEventListener('touchstart', this.startDrag);
            container.removeEventListener('touchmove', this.duringDrag);
            container.removeEventListener('touchend', this.stopDrag);
            container.removeEventListener('touchcancel', this.stopDrag);
            
            this.isDragging = false;
            this.hasDragged = false;
        },
    },
    beforeMount(){
        if(this.$store.getters._theme){
            this.$store.commit('SKIN_THEME', this.$store.getters._theme)
            if(this.$store.getters._theme == 2){
            document.documentElement.classList.toggle('theme02');
            }
        }
    },
    mounted(){
        if(window.valid) {
            this.$store.commit('FIRST_LOAD', 1);
            this.getLSMatchList();
            this.refreshTimer()
        } else {
            this.$store.commit('FIRST_LOAD', 0);
        }

        // this.bindScrollEvents();
        // this.updateScrollButtons();
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', this.handleResize)
        }
        $(document).ready(function () {
            $( "#loading-root-ele" ).hide();
            var lastScrollTop = 0;
        });

        var playframe_original_style;
        window.addEventListener("message", function(ev){
            if (typeof ev.data !== "object") return;
            if (!ev.data.type) return;
            if (ev.data.type !== "full_screen_click") return;
            var playframe_message = ev.data.message;
            var playframe = document.getElementById("mainLSTViframe"); // can replace with your iframe id
        
            if (Object.keys(playframe_message).length > 0){
                var playframe_fullscreen_style = "";
                Object.keys(playframe_message).forEach((val, idx) => {
                    var style_name = val;
                    playframe_fullscreen_style += `${style_name}: ${playframe_message[val]};`;
                });
                playframe_original_style = playframe.getAttribute("style");
                playframe.setAttribute("style", playframe_fullscreen_style);
                openFullscreen()
            } else{
                if(playframe_original_style != null){
                    closeFullscreen()
                    playframe.setAttribute("style", playframe_original_style);
                }
                else{
                    playframe.removeAttribute("style");
                }
            }
        });

        this.pointerMQ = window.matchMedia('(pointer: coarse)')
        this.pointerMQ.addEventListener('change', this.handlePointerChange)
        this.handlePointerChange()
    },
    // created() {
    // },
    beforeUnmount() {
        this.unbindScrollEvents();
        window.removeEventListener('resize', this.handleResize);
        if (window.visualViewport) {
            window.visualViewport.removeEventListener('resize', this.handleResize)
        }
        this.pointerMQ.removeEventListener('change', this.handlePointerChange)
    },
    destroyed(){
        this.clearTimer()
    },
  }
 
</script>
<style lang="scss">
    @import "~@/styles/home/app";
    @import "~@/styles/home/user-h5"; 
    @import "~@/styles/home/chunk-vendors";
    @import "~@/styles/home/live";
</style>



// WEBPACK FOOTER //
// resources/score/vue/apps/home/live.vue